import React from 'react'

export default function FAQs() {

    // on hash click
    const handleHashUrlClick = (ev, hash) => {
        ev.preventDefault()
        if (hash) {
            const elem = document.getElementById(hash)

            // scrolling to element
            if (elem) {
                window.scrollTo(0, elem.offsetTop)
            }
        }
    }
    return (
        <div className="page-split-view">
            <div className="inner">
                {/* text */}
                <div className="text-sec">
                    <div className="frac mb-3" id="ppt1">
                        <p className="head st-fw-600 st-fs-15 text-decoration-underline mb-2">General</p>
                        <ul className="ps-3">
                            <li className="st-fs-15">
                                Transactions made on this website will show a charge from 'Hi Life Tobacco Inc.' on your credit card or bank statement
                            </li>
                        </ul>
                    </div>
                </div>

                {/* text */}
                <div className="text-sec">
                    <div className="frac mb-3" id="ppt1">
                        <p className="head st-fw-600 st-fs-15 text-decoration-underline mb-2">Shipping</p>
                        <ul className="ps-3">
                            <li className="st-fs-15">
                                We offer Free Shipping on orders of $150 or more.
                            </li>
                            <li className="st-fs-15">
                                All orders are packaged and shipped in discreet brown packaging.
                            </li>
                            <li className="st-fs-15">
                                We use FedEx, UPS and USPS to ship the packages.
                            </li>
                        </ul>
                    </div>
                </div>

                {/* text */}
                <div className="text-sec">
                    <div className="frac mb-3" id="ppt1">
                        <p className="head st-fw-600 st-fs-15 text-decoration-underline mb-2">Processing Time</p>
                        <ul className="ps-3">
                            <li className="st-fs-15">
                                All orders are processed and shipped within 24hrs – 48hrs (Monday – Friday).
                            </li>
                            <li className="st-fs-15">
                                Orders received on the weekends and holidays will be processed on the next business day.
                            </li>
                        </ul>
                    </div>
                </div>

                {/* text */}
                <div className="text-sec">
                    <div className="frac mb-3" id="ppt1">
                        <p className="head st-fw-600 st-fs-15 text-decoration-underline mb-2">Returns / Exchanges</p>
                        <ul className="ps-3">
                            <li className="st-fs-15">
                                We do not accept returns.
                            </li>
                            <li className="st-fs-15">
                                We offer exchanges on products.
                                <ul className="ps-3">
                                    <li className="st-fs-15">
                                        You can email us at info@kraveglassusa.com to initiate your request to exchange your product.
                                    </li>
                                    <li className="st-fs-15">
                                        Please note that exchange can be made for a product equal to or more in value of the product you originally purchased.
                                    </li>
                                    <li className="st-fs-15">
                                        The product you originally purchased must be in brand new condition with its original packaging intact.
                                    </li>
                                    <li className="st-fs-15">
                                        You will be responsible for all applicable shipping charges associated with the exchange.
                                    </li>
                                    <li className="st-fs-15">
                                        A 20% restocking fee may be applied.
                                    </li>
                                    <li className="st-fs-15">
                                        Please allow 1-2 business days to process your exchange.
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* text */}
                <div className="text-sec">
                    <div className="frac mb-3" id="ppt1">
                        <p className="head st-fw-600 st-fs-15 text-decoration-underline mb-2">Damages / Defects</p>
                        <ul className="ps-3">
                            <li className="st-fs-15">
                                All orders must be carefully inspected upon receipt.
                            </li>
                            <li className="st-fs-15">
                                Please be sure to report any damages or defects within 24 hours of receipt of your package.
                            </li>
                            <li className="st-fs-15">
                                We will not entertain any claims after 24 hours of delivery.
                            </li>
                        </ul>
                    </div>
                </div>


            </div>
        </div>
    )
}
